import { GoogleFontLoader } from 'components/GoogleFontLoader/GoogleFontLoader'
import { TextPreset } from './Types'
import Styles from './TextTab.module.scss'
import { BlazeFontLoader } from 'components/BlazeFontLoader/BlazeFontLoader'

interface Props {
  preset: TextPreset
}

export const TextPresetThumbnail = ({ preset }: Props) => (
  <div
    className={Styles.presetThumbnail}
    style={{ backgroundImage: `url(${preset.preview})` }}
    aria-label={`Preset: ${preset.props.text}`}
  >
    {preset.props.fontFamily && (
      <>
        <GoogleFontLoader family={preset.props.fontFamily} />
        <BlazeFontLoader name={preset.props.fontFamily} />
      </>
    )}
  </div>
)
